import React from "react";
import { Button, Table } from "react-bootstrap";
import user from "../../../../Assets/images/user.png";

const TableData = ({ subscriptionData }) => {
  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th className="fw-normal border-0">
              <Button className="border-0 p-0" variant="transparent">
                Full Name
              </Button>
            </th>
            <th className="fw-normal border-0">Email</th>
            <th className="fw-normal border-0">Plan Name</th>
            <th className="fw-normal border-0">Start Date</th>
            <th className="fw-normal border-0">End Date</th>
            <th className="fw-normal border-0">Plan Status</th>
          </tr>
        </thead>
        <tbody>
          {subscriptionData && subscriptionData.length > 0 ? (
            subscriptionData?.map((data, key) => (
              <tr key={key}>
                <td>
                  <div className="d-flex align-items-center profile">
                    <div className="imgWrp rounded-circle me-2">
                      <img
                        src={data?.profileImage ? data?.profileImage : user}
                        alt=""
                        className="img-fluid rounded-circle"
                        style={{ height: 40, width: 40 }}
                      />
                    </div>
                    <div className="content">
                      <p className="m-0 fw-sbold">
                        {data?.user_name ? data?.user_name : "-"}
                      </p>
                    </div>
                  </div>
                </td>
                <td>{data?.user_email ? data?.user_email : "-"}</td>
                <td>{data?.plan_name ? data?.plan_name : "-"}</td>
                <td>
                  {data?.start_date
                    ? new Date(data.start_date).toLocaleDateString()
                    : "-"}
                </td>
                <td>
                  {data?.end_date
                    ? new Date(data.end_date).toLocaleDateString()
                    : "-"}
                </td>
                <td>
                  {data?.plan_status ? "Active" : "Inactive"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No data available</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};

export default TableData;
